import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import spinnerIcon from './assets/spinner.svg';

import { ButtonWrapper, Content, Icon } from './styled';
import {
    TEXT_ONLY,
    ICON_AND_TEXT,
    ICON_ONLY,
    SQUARE,
    LOZENGE,
    SMALL,
    MEDIUM,
    LARGE,
    LEFT,
    RIGHT
} from './constants';

/**
 * Button component
 * Supports different styles through setting primary, danger & info props
 */
const CustomButton = (props) => {
    const {
        text,
        icon,
        onClick,
        disabled,
        className,
        type,
        size,
        alignIcon,
        hasSpinner
    } = props;

    const styleProps = {};
    ['primary', 'danger', 'info', 'disabled', 'inverse'].forEach((style) => {
        if (props[style]) {
            styleProps[style] = true;
        }
    });

    let buttonState = TEXT_ONLY;
    if (icon && text) {
        buttonState = ICON_AND_TEXT;
    } else if (icon) {
        buttonState = ICON_ONLY;
    }

    function renderIcon(iconType) {
        return (
            <Icon
                buttonState={buttonState}
                size={size}
                alignIcon={alignIcon}
                hasSpinner={hasSpinner}
                key={1}
            >
                <Isvg src={iconType} cacheRequests={false} />
            </Icon>
        );
    }

    function getContent() {
        if (!icon) {
            return text;
        }
        if (alignIcon === RIGHT) {
            return [text, renderIcon(icon)];
        }
        return [renderIcon(icon), text];
    }

    return (
        <ButtonWrapper
            {...styleProps}
            buttonState={buttonState}
            type={type}
            size={size}
            disabled={hasSpinner || disabled}
            hasSpinner={hasSpinner}
            className={className}
            role="button"
            tabIndex="0"
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
        >
            {hasSpinner && <Content hasSpinner>{renderIcon(spinnerIcon)}</Content>}
            {!hasSpinner && <Content>{getContent()}</Content>}
        </ButtonWrapper>
    );
};

CustomButton.SQUARE = SQUARE;
CustomButton.LOZENGE = LOZENGE;
CustomButton.SMALL = SMALL;
CustomButton.MEDIUM = MEDIUM;
CustomButton.LARGE = LARGE;
CustomButton.LEFT = LEFT;
CustomButton.RIGHT = RIGHT;

CustomButton.propTypes = {
    /** Text to display inside of button (can be combined with icon) */
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /** SVG icon to display inside of button (can be combined with text) */
    icon: PropTypes.string,
    /** If use both icon and text aligns icon to side of text */
    alignIcon: PropTypes.oneOf([CustomButton.LEFT, CustomButton.RIGHT]),
    /** Callback when button is clicked */
    onClick: PropTypes.func.isRequired,
    /** Button cannot be clicked, and displays with an alpha and a not-allowed cursor */
    disabled: PropTypes.bool,
    /** Type of button this is, quick way to apply styles */
    type: PropTypes.oneOf([CustomButton.SQUARE, CustomButton.LOZENGE]),
    /** Size of button */
    size: PropTypes.oneOf([CustomButton.SMALL, CustomButton.MEDIUM, CustomButton.LARGE]),
    /** Custom class to attach to parent div - use this to override any styles */
    className: PropTypes.string,
    /** hasSpinner * */
    hasSpinner: PropTypes.bool
};

CustomButton.defaultProps = {
    type: CustomButton.SQUARE,
    size: CustomButton.MEDIUM,
    alignIcon: CustomButton.LEFT,
    primary: false,
    danger: false,
    info: false,
    disabled: false,
    inverse: false,
    hasSpinner: false
};

export default CustomButton;



// WEBPACK FOOTER //
// ./components/button/index.js